import jssVariables from "../../jss_setup";

export const TransfersSearchStrip = {
  searchStripContainer: {
    background: "#e8eff2",

    smallscreen: {
      background: "#b9ced8",
    },
  },
};

export const TransfersFiltersBar = {
  filtersBar: {
    background: "#e8eff2",
  },
  btnLbl: {
    fontWeight: "bold",
  },
  itemTextLabel: {
    color: jssVariables.colors.base_color,
    fontWeight: 500,
  },
};

export const TrfSearchStripDest = {
  originText: {
    borderRadius: 0,
  },
  destinationText: {
    borderRadius: 0,
  },
};

export const TrfSearchStripDate = {
  dateAndTimeText: {
    borderRadius: 0,
  },
};

export const TrfSearchStripPax = {
  paxText: {
    borderRadius: 0,
  },
};

export const transferStyles = {
  bookBtn: {
    ButtonDefault: {
      background: "black",
      borderColor: "black",
      "&:hover": {
        color: "black",
        background: "white",
      },
    },
  },
  priceComponent: {
    color: jssVariables.colors.base_color,
    fontSize: "x-large",
    smallscreen: {
      fontSize: "x-large",
      fontWeight: 800,
    },
  },
};

export const transferFilters = {
  filtersContr: {
    padding: `calc(${jssVariables.normal_gap} * 3)`,
    paddingBottom: jssVariables.double_gap,
    smallscreen: {
      padding: jssVariables.normal_gap,
      paddingBottom: jssVariables.normal_gap,
    },
  },
  divider: {
    display: "none",
  },
  form: {
    paddingTop: jssVariables.double_gap,
    paddingBottom: jssVariables.double_gap,
    smallscreen: {
      padding: jssVariables.normal_gap,
    },
  },
  actions: {
    paddingTop: jssVariables.double_gap,
  },
};

export const TrfPreBook = {
  headerItemText: {
    fontWeight: "bold",
  },
  priceComponent: {
    smallscreen: {
      fontWeight: 800,
      fontSize: "x-large",
    },
  },
};

export const TrfCxls = {
  cxls: {
    fontWeight: 500,
  },
};

export const TravellersForms = {
  requiredFieldsLabel: {},
};
